import { Connector } from '@web3-react/types'
import { useEffect } from 'react'
import { useConnectedWallet } from '../ConnectedWalletProvider'
import { getConnection } from './utils'
import { Connection, gnosisSafeConnection, networkConnection } from './connection'

async function connect(connector: Connector) {
    try {
        if (connector.connectEagerly) {
            await connector.connectEagerly()
        } else {
            await connector.activate()
        }
    } catch (error) {
        console.debug(`wallet eager connection error: ${error}`)
    }
}

export default function useEagerlyConnect() {
    const { selectedWallet, setSelectedWallet } = useConnectedWallet()
    let selectedConnection: Connection | undefined
    if (selectedWallet) {
        try {
            selectedConnection = getConnection(selectedWallet)
        } catch {
            setSelectedWallet(undefined)
        }
    }

    useEffect(() => {
        connect(gnosisSafeConnection.connector)
        connect(networkConnection.connector)

        if (selectedConnection) {
            connect(selectedConnection.connector)
        } // The dependency list is empty so this is only run once on mount
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
}
